import * as THREE from 'three';

export default class Portal {
  constructor(experience) {
    this.experience = experience;
    this.scene = this.experience.scene;

    this.group = new THREE.Group();
    this.group.position.set(0, 0, -2.5);
    this.scene.add(this.group);

    // Removed the loud backdrop disc/circle as requested
    this.setSubtleRings();
  }

  setSubtleRings() {
    this.rings = [];

    // Multi-depth portal rings creating an architectural spatial frame
    const ringConfigs = [
      { radius: 2.6, tube: 0.007, speed: 0.09, rotZ: 0, opacity: 0.14, z: 0.8 },
      { radius: 3.2, tube: 0.008, speed: -0.07, rotZ: Math.PI / 4, opacity: 0.11, z: 0.0 },
      { radius: 3.8, tube: 0.009, speed: 0.05, rotZ: Math.PI / 3, opacity: 0.08, z: -1.2 }
    ];

    const ringMaterial = new THREE.MeshBasicMaterial({
      color: new THREE.Color('#38bdf8'),
      transparent: true,
      opacity: 0.1,
      wireframe: false
    });

    ringConfigs.forEach(config => {
      const geometry = new THREE.TorusGeometry(config.radius, config.tube, 16, 64);
      const mat = ringMaterial.clone();
      mat.opacity = config.opacity;
      const mesh = new THREE.Mesh(geometry, mat);
      mesh.position.z = config.z;
      mesh.rotation.z = config.rotZ;
      this.group.add(mesh);
      this.rings.push({ mesh, speed: config.speed });
    });
  }

  update(elapsed) {
    this.rings.forEach(item => {
      item.mesh.rotation.z += item.speed * 0.01;
    });
  }
}
